//import logo from "./logo.svg";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { useEffect, useState } from "react";
import NoInternet from "./NoInternet";
import Layout from "./Component/Home/Layout";
import Routing from "./Routes/routers";
import Unauthorized from "./Routes/Unauthorized";
import ChatWidget from "./Component/Support/SupportChat";

function App() {
  const [online, setOnline] = useState(window.navigator.onLine);
  const [userRights, setUserRights] = useState("");

  useEffect(() => {
    const handleOnlineStatus = () => {
      setOnline(window.navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);
    console.log(userRights);
    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);

  return (
    <BrowserRouter>
      {!online && <NoInternet />}

      {
        //online && (
        //  <Routing userRights={userRights} setUserRights={setUserRights} />
        // )
      }
      {online && (
        <Layout setUserRights={setUserRights}>
          <Routing userRights={userRights} setUserRights={setUserRights} />
        </Layout>
      )}
      <ChatWidget />
    </BrowserRouter>
  );
}

export default App;
